import { useContext } from "react";
import SecondaryLogo from "../assets/icons/sabb-logo.svg";
import PrimaryLogo from '../assets/icons/primary-logo.svg';
import navListEn from "../data/english/navbar-list";
import navListAr from "../data/arabic/navbar-list-ar";
import CloseIcon from "../assets/icons/close-icon-2.svg";
import MenuIcon from "../assets/icons/menu-icon.svg";
import ArrowRight from "../assets/icons/arrow-right.svg";
import ArrowRightRed from "../assets/icons/arrow-right-red.svg";
import BgStrategy from "../assets/images/backgrounds/our-esg-strategy.jpg";
import { LangContext, PageContext } from "../App";
import pagesNames from "../constants/pages-names";

import InstagramIcon from '../assets/icons/instagram-icon.svg';
import FacebookIcon from '../assets/icons/facebook-icon.svg';
import TwitterIcon from '../assets/icons/twitter-icon.svg';
import LinkedinIcon from '../assets/icons/linkedin.svg';

const icons : string[] = [
    TwitterIcon,
    FacebookIcon,
    InstagramIcon,
    LinkedinIcon,
];

const socialMediaList = [
  {
    image : {
        name : "twitter-icon.svg",
        description : "see our twitter account",
        alt : "twitter icon",
    },
    path : "https://twitter.com",
  },
  {
      image : {
          name : "facebook-icon.svg",
          description : "see our facebook page",
          alt : "facebook icon",
      },
      path : "https://www.facebook.com/",
  },
  {
      image : {
          name : "instagram-icon.svg",
          description : "see our instagram account",
          alt : "instagram icon",
      },
      path : "https://www.instagram.com/alawwalsab/",
  },
  {
      image : {
          name : "linkedin.svg",
          description : "See our linkedin account",
          alt : "linkedin icon",
      },
      path : "https://www.linkedin.com/company/alawwalsab"
  }
]

const NavbarTwo = () => {
  const pageContext = useContext(PageContext);
  const { lang, handleChangeLang } = useContext(LangContext);

  const navList = lang === 0 ? navListEn : navListAr;

  return (
    <div id="navbar" className={`navbar-two ${lang === 0 ? "" : "rtl"}`}>
      <div className="relative-wrapper">
        <div className="wrapper-larg">
          <div className="nav-container">
              <button
                // to="/"
                id="homeLink"
                className="nav-logo"
                aria-label="Go to Home page"
                title="Home"
                role={"link"}
                onClick={(): void => {
                  pageContext.setSubmenuIndex(0);
                  pageContext.handleChangePage(pagesNames.home);
                }}
              >
                {/* <img src={PrimaryLogo} className='secondary-logo' alt="SABB Logo" /> */}
                <img src={PrimaryLogo} className="primary-logo" alt="SAB Logo" />
              </button>
              <button
                type="button"
                className="menu-button"
                title="Open main menu"
                onClick={() =>
                  pageContext?.setToggleMenu(!pageContext.toggleMenu)
                }
              >
                <img src={MenuIcon} alt="menu icon" aria-hidden="true" />
              </button>
            <nav
              className={`nav-menu ${pageContext.toggleMenu ? "active" : ""}`}
            >
              <div className={`lang-menu-button-container ${lang === 0 ? "" : "rtl"}`}>
                <button 
                  type="button"
                  className={`lang-menu-button ${lang === 0 ? "" : "rtl"}`}
                  title={lang === 0 ? "Change language to arabic" : "Change language to english"}
                  onClick={() => {
                    handleChangeLang(lang === 0 ? 1 : 0)
                  }}
                >
                  {lang === 0 ? "العربية" : "English"}
                </button>
              </div>
              <ul role={"list"}>
                {navList.map((item, index) => (
                  <>
                    <li
                      key={index}
                      className={`nav-item ${(item.path.pageId === pageContext.currentPage.pageId) ? "active" : ""} ${((index + 1) === pageContext.submenuIndex) ? "active-two" : ""}`}
                      role="listitem"
                    >
                      {item.submenu ? (
                        <>
                          <button
                            type="button"
                            id={item.buttonId}
                            className={`nav-link ${
                              item.path === pageContext.currentPage ? 
                              "active" :
                              ""
                            }`}
                            aria-expanded={
                              index + 1 === pageContext.submenuIndex
                                ? "true"
                                : "false"
                            }
                            // aria-label="Open submenu"
                            // aria-controls={item.submenu.id}
                            title={(index + 1 === pageContext.submenuIndex) ? `Go to ${item.title} page` : `Open ${item.title} submenu`}
                            role={
                              index + 1 === pageContext.submenuIndex &&
                              item.submenu
                                ? "link"
                                : "button"
                            }
                            onClick={() => {
                              // setSubmenuIndex(index + 1)
                              if (index + 1 === pageContext.submenuIndex) {
                                pageContext.handleChangePage(item.path);
                              } else {
                                pageContext.setSubmenuIndex(index + 1);
                              }
                            }}
                          >
                            {item.title}
                            <span className="arrow-right-icon">
                              <img src={ArrowRight} className={lang === 0 ? "" : "rotate-rtl"} alt=""  aria-hidden="true" />
                            </span>
                          </button>
                          <div
                            id={`submenu-${item.title}`}
                            className={`nav-submenu ${
                              index + 1 === pageContext.submenuIndex
                                ? "active"
                                : ""
                            } ${lang === 0 ? "" : "rtl"}`}
                            // role="menu"
                            aria-label={item.buttonId}
                            // aria-hidden={((index + 1) === submenuIndex) ? "true" : "false"}
                          >
                            <div className="overlay" onClick={(): void => {
                              pageContext.setSubmenuIndex(0);
                            }}></div>
                            <div className="wrapper-larg">
                              <div className="submenu-content">
                                <button
                                  type="button"
                                  className="back-button"
                                  aria-label="Back to main menu"
                                  onClick={() => pageContext.setSubmenuIndex(0)}
                                >
                                  <img src={ArrowRight} className={`back-icon ${lang === 0 ? "" : "rtl"}`} alt="arrow right icon" aria-hidden="true" />
                                  <span>{lang === 0 ? "Main menu" : "العودة"}</span>
                                </button>
                                {index + 1 < navList.length ? (
                                  <button
                                    type="button"
                                    className="global-skip-link"
                                    title={`Go to ${item.submenu.title} page`}
                                    onClick={(): void =>
                                      pageContext.setSubmenuIndex(index + 2)
                                    }
                                  >
                                    Skip to {navList[index + 1].title}
                                  </button>
                                ) : (
                                  ""
                                )}
                                <div className="submenu-row">
                                  <div className="submenu-col">
                                    <span className="title">
                                      {item.submenu.title}
                                    </span>
                                    <p className="subtitle">
                                      {item.submenu.subtitle}
                                    </p>
                                    <button
                                      type="button"
                                      className="button"
                                      aria-label={`Read more about ${item.submenu.title}`}
                                      title={`Read more about ${item.submenu.title}`}
                                      onClick={(): void =>
                                        pageContext.handleChangePage(
                                          item.submenu.button.path
                                        )
                                      }
                                    >
                                      {item.submenu.button.text}
                                      <img src={ArrowRightRed} className={lang === 0 ? "" : "rotate-rtl"} alt="" aria-hidden="true" />
                                    </button>
                                  </div>
                                  <div className="submenu-col">
                                    <ul className="submenu-list">
                                      {item.submenu.list.map((item, index) => (
                                        <li
                                          key={index}
                                          className={lang === 0 ? "" : "translate-rlt"}
                                          // role="menuitem"
                                        >
                                          <button
                                            className="list-link"
                                            id={`${item.path.name.toLocaleLowerCase()}`}
                                            role="button"
                                            title={`Go to ${item.text} page`}
                                            onClick={() => {
                                              pageContext.handleChangePage(
                                                item.path
                                              );
                                            }}
                                          >
                                            {item.text}
                                          </button>
                                        </li>
                                      ))}
                                    </ul>
                                  </div>
                                  <div className="submenu-col">
                                    <img
                                      src={item.submenu.image ? require(`../assets/images/menu/${item.submenu.image.name}`) : BgStrategy}
                                      alt={"Our ESG Strategy background"}
                                      className="image"
                                    />
                                  </div>
                                </div>
                                <button
                                  type="button"
                                  className={`close-button ${lang === 1 ? "rtl" : ""}`}
                                  aria-label="close submenu"
                                  title={"Close submenu"}
                                  onClick={(): void => {
                                    pageContext.setSubmenuIndex(0);
                                  }}
                                >
                                  <img src={CloseIcon} alt=""  aria-hidden="true" />
                                </button>
                              </div>
                            </div>
                          </div>
                        </>
                      ) : (
                        <button
                          key={index}
                          type="button"
                          className="nav-link"
                          title={`Go to ${item.title} page`}
                          onClick={() => pageContext.handleChangePage(item.path)}
                        >
                          {item.title}
                        </button>
                      )}
                    </li>
                  </>
                ))}
              </ul>
              {/* <div className="space-50 only-mob"></div>
              <div className="space-50 only-mob"></div> */}
              <div role="list" className="social-list">
                  {socialMediaList.map((item, index) => (
                      <a
                          role="listitem"
                          key={index} 
                          href={item.path}
                          className="icon"
                          title={item.image.description}
                          aria-label={item.image.description}
                      >
                          <img src={icons[index]} alt={item.image.alt} style={{ color : "red" }} />
                      </a>
                  ))}
              </div>
            </nav>
            <div className={`lang-button-container ${lang === 0 ? "" : "rtl"}`}>
              <button 
                type="button"
                className={`lang-button ${lang === 0 ? "" : "rtl"}`}
                title={lang === 0 ? "Change language to arabic" : "Change language to english"}
                onClick={() => {
                  handleChangeLang(lang === 0 ? 1 : 0)
                }}
              >
                {lang === 0 ? "العربية" : "English"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NavbarTwo;
